// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React, { useState, useRef } from 'react'
import { animated } from 'react-spring'
import { scaleLinear } from 'd3-scale'
import css from './card.module.scss'

export default function CardImage({ url, fullSizeUrl }: { url: string; fullSizeUrl: string }) {
  const imageUrl = fullSizeUrl || url
  const [firstLoad, setFirstLoad] = useState(true)
  const [expanded, setExpanded] = useState(false)
  const [thumbnailOpacity, setThumbnailOpacity] = useState(1)
  const [imageDimensions, setImageDimensions] = useState<{ width: number; height: number } | null>(
    null
  )
  const [imageRect, setImageRect] = useState(null)
  const imageRef = useRef()

  const thumbnailScale = scaleLinear().range([0, 120])
  const fullImageScale = scaleLinear().range([0, 600])

  if (imageDimensions) {
    const domain = [0, Math.max(imageDimensions.width, imageDimensions.height)]
    thumbnailScale.domain(domain)
    fullImageScale.domain(domain)
  }

  const renderBackdrop =
    !document.querySelector('.FinderPopOver---overlay') &&
    !document.querySelector('.WayfinderToolbar---overlay')

  return (
    <div>
      <div
        className={css.imgContainer}
        onClick={(e) => {
          if (fullSizeUrl) {
            e.stopPropagation()
            setExpanded(true)
            setFirstLoad(false)
            imageRef.current && setImageRect(imageRef.current.getBoundingClientRect())
          }
        }}
      >
        {firstLoad ? (
          <div
            native={true}
            from={{ opacity: 0 }}
            to={{ opacity: imageDimensions && thumbnailOpacity ? 1 : 0 }}
          >
            {(animStyles) => (
              <animated.div style={animStyles}>
                <img
                  alt="avatar"
                  ref={imageRef}
                  src={imageUrl}
                  style={{
                    cursor: fullSizeUrl ? 'pointer' : 'default',
                    width: imageDimensions ? thumbnailScale(imageDimensions.width) : '100%',
                    height: imageDimensions ? thumbnailScale(imageDimensions.height) : 'auto',
                  }}
                  onLoad={(e) => {
                    setImageDimensions({
                      width: e.target.width,
                      height: e.target.height,
                    })
                  }}
                />
              </animated.div>
            )}
          </div>
        ) : (
          <img
            alt="avatar"
            ref={imageRef}
            src={imageUrl}
            style={{
              cursor: fullSizeUrl ? 'pointer' : 'default',
              opacity: thumbnailOpacity,
              width: imageDimensions ? thumbnailScale(imageDimensions.width) : '100%',
              height: imageDimensions ? thumbnailScale(imageDimensions.height) : 'auto',
            }}
            onLoad={(e) => {
              setImageDimensions({
                width: e.target.width,
                height: e.target.height,
              })
            }}
          />
        )}
      </div>
      {imageRect && imageDimensions && (
        <div
          native={true}
          onStart={() => expanded && setThumbnailOpacity(0)}
          onRest={() => !expanded && setThumbnailOpacity(1)}
          from={{
            left: imageRect.x,
            top: imageRect.y,
            width: imageRect.width,
            height: imageRect.height,
            opacity: 0,
          }}
          enter={{
            width: fullImageScale(imageDimensions.width),
            height: fullImageScale(imageDimensions.height),
            top: 60,
            left: window.innerWidth / 2 - fullImageScale(imageDimensions.width) / 2,
            opacity: 1,
          }}
          leave={{
            left: imageRect.x,
            top: imageRect.y,
            width: imageRect.width,
            height: imageRect.height,
            opacity: 0,
          }}
        >
          {expanded &&
            ((animatedStyles) => (
              <div style={{ zIndex: 1000 }}>
                {/* Backdrop */}
                {renderBackdrop && (
                  <animated.div
                    onClick={(e) => {
                      e.stopPropagation()
                      setExpanded(false)
                    }}
                    style={{
                      zIndex: 100,
                      position: 'fixed',
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: 'rgba(0,0,0,0.7)',
                      opacity: animatedStyles.opacity,
                    }}
                  />
                )}
                {/* Expanded image */}
                <animated.img
                  alt="avatar"
                  src={fullSizeUrl}
                  style={{
                    ...animatedStyles,
                    position: 'fixed',
                    opacity: 1,
                    zIndex: 100,
                  }}
                />
                {/* Close button */}
                <animated.div
                  className={css.closeButton}
                  onClick={(e) => {
                    e.stopPropagation()
                    setExpanded(false)
                  }}
                  style={{
                    top: 64,
                    left: window.innerWidth / 2 + fullImageScale(imageDimensions.width) / 2 - 45,
                    opacity: animatedStyles.opacity,
                  }}
                >
                  <i className="far fa-times" />
                </animated.div>
              </div>
            ))}
        </div>
      )}
    </div>
  )
}
